<template>
  <div>
    <div class="player">
      <div class="container">
        <YouTube
          @ready="firstSetPlayer"
          id="player"
          class="yt"
          height="90"
          width="160"
          ref="youtube"
          src=""
        />
        <div class="misc">
          <div class="title">
            <div class="">{{ screenTitle }}</div>
          </div>
          <div class="buttons">
            <i @click="back" class="p-m-2 pi pi-step-backward"></i>
            <i @click="play" v-if="!nowPlaying" class="p-m-2 pi pi-play"></i>
            <i @click="stop" v-if="nowPlaying" class="p-m-2 pi pi-pause"></i>
            <i @click="forward" class="p-m-2 pi pi-step-forward"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useStore } from "vuex";
import YouTube from "vue3-youtube";
import firebase from "../firebase/firebase";

export default defineComponent({
  name: "Player",
  components: { YouTube },
  data() {
    // eslint-disable-next-line
    let player;
    // eslint-disable-next-line
    let songData;
    songData = ref(songData);
    return {
      player: player,
      screenTitle: "",
      songData: songData,
      first: true,
      nowPlaying: false,
    };
  },
  setup() {
    console.log("setup");
    const list = useStore().state.list; // vuexからリストの読み取り
    const store = useStore();
    const _sleep = (ms) =>
      new Promise((resolve) => setTimeout(resolve, ms));
    return {
      list,
      _sleep,
      store,
    };
  },
  mounted() {
    console.log("mounted");
    this.player = this.$refs.youtube; //ytplayerへの参照を取得
    this.getSongData();
  },
  methods: {
    firstSetPlayer: async function () {
      if (this.first) {
        await this.setPlayer();
        setInterval(this.checkEndTime, 500);
      }
      this.first = false;
    },
    onStateChange() {
      console.log("state-changed");
    },
    play() {
      console.log("play");
      this.player.playVideo();
      this.nowPlaying = true;
    },
    stop() {
      console.log("stop");
      this.player.pauseVideo();
      this.nowPlaying = false;
    },
    forward: async function () {
      console.log("forward");
      this.store.commit("increment");
      console.log(this.list.cursor);
      // this.getSongData();
      // this.setPlayer();
    },
    back: async function () {
      console.log("back");
      this.store.commit("decrement");
      console.log(this.list.cursor);
      // this.getSongData();
      // this.setPlayer();
    },
    getSongData: async function () {
      console.log("getSongData");
      let songId = this.list.ids[this.list.cursor];

      console.log("cursor:", this.list.cursor);
      console.log(songId);
      await firebase
        .firestore()
        .collection("songs")
        .doc(songId)
        .get()
        .then((d) => {
          this.songData = d.data();
          console.log("getSongData Complete");
        })
        .catch((err) => {
          console.log(err);
        });
      if (!this.first) this.setPlayer();
    },
    checkEndTime() {
      const t = this.player.getCurrentTime();
      if (this.songData.end < t) {
        this.forward();
      }
    },
    setPlayer: async function () {
      console.log("setPlayer();");
      console.log(this.songData);
      this.player.cueVideoById({
        videoId: this.songData.videoId,
        startSeconds: this.songData.start,
        suggestedQuality: "small",
      });
      this.screenTitle = this.songData.screenTitle;
      await this._sleep(50);
      this.play();
    },
  },
  computed: {
    cursored() {
      return this.store.state.list.ids[this.store.state.list.cursor];
    },
  },
  watch: {
    cursored() {
      this.getSongData();
    },
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.player {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 90px;
  border-top: solid;
  border-top-width: 3px;
  border-top-color: rgb(243, 243, 243);
  z-index: 6;
  background-color: rgb(235, 235, 235);
}
i {
  font-size: 16pt;
}
.container {
  position: relative;
  width: 360px;
  margin: 0 auto;
}
.misc {
  position: absolute;
  overflow: hidden;
  top: 0px;
  left: 0px;
  height: 90px;
  width: 200px;
  background-color: white;
}
.yt {
  position: absolute;
  left: 200px;
}
.buttons {
  margin-top: 6px;
  border-top: solid;
  border-top-width: 2px;
  border-top-color: whitesmoke;
}
.title {
  text-align: center;
  vertical-align: bottom;
  margin-top: 13px;
}
</style>
